import React, { useEffect } from 'react';
import './scss/MoreMembers.scss';
import { fetchMembers, clearBoardMembers } from '../../redux/Slices/memberSlice';
import { useDispatch, useSelector } from 'react-redux';
import MemberImage from './MemberImage';
import MoreMembersImage from './MoreMembersImage';

const MoreMembers = ({ boardId, id, type = 'board' }) => {

    const dispatch = useDispatch();

    const { boardMembers, currentBoardId } = useSelector(state => state.member) || {};
    const targetId = id || boardId;

    useEffect(() => {
        if (currentBoardId !== targetId) {
            dispatch(clearBoardMembers());
            dispatch(fetchMembers({ type, id: targetId }));
        }
    }, [targetId, type, dispatch, currentBoardId]);


    return (
        <div className="more-members">
            <h2>Members</h2>

            <div className="group">
                <MoreMembersImage boardId={targetId} members={boardMembers} type={type} size={30} />
            </div>
        </div>

    );
};

export default MoreMembers;
